import { render, staticRenderFns } from "./GroupMailList.vue?vue&type=template&id=cce63a4e"
import script from "./GroupMailList.vue?vue&type=script&lang=js"
export * from "./GroupMailList.vue?vue&type=script&lang=js"
import style0 from "./GroupMailList.vue?vue&type=style&index=0&id=cce63a4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports